import { language } from "shared/language";

export const ADMIN_EMAIL_INVALID = language.admin_email_invalid;
